import React from 'react';
import { Droplet, Calendar, MapPin } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-[72px] md:pt-[80px] md:min-h-screen flex flex-col md:flex-row bg-brand-light" data-id="element-144">
      {/* Left Content */}
      <div className="w-full md:w-1/2 flex flex-col justify-center px-6 md:px-12 lg:px-20 py-12 md:py-20 z-10" data-id="element-145">
        <div className="max-w-xl mx-auto md:mx-0" data-id="element-146">
          <div className="inline-block bg-brand-teal/10 text-brand-teal text-xs font-bold tracking-wider uppercase px-3 py-1.5 rounded-full mb-6" data-id="element-147">
            Luxury Pool Care | Madison, MS
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-brand-teal leading-[1.1] mb-6" data-id="element-148">
            Clean. Balanced. Swim Ready.
          </h1>

          <p className="text-lg md:text-xl text-brand-muted mb-8 leading-relaxed" data-id="element-149">
            Premium pool maintenance and repair services for Madison and
            surrounding areas. We handle the hard work so you can enjoy the
            water.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-12" data-id="element-150">
            <a href="#contact" className="bg-brand-amber text-white px-8 py-4 rounded-full font-semibold text-center hover:bg-brand-amber/90 transition-colors min-h-[48px] flex items-center justify-center shadow-soft" data-id="element-151">
              Contact for free quote
            </a>
            <a href="#services" className="border-2 border-brand-teal text-brand-teal px-8 py-4 rounded-full font-semibold text-center hover:bg-brand-teal/5 transition-colors min-h-[48px] flex items-center justify-center" data-id="element-152">
              See Our Services
            </a>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 pt-8 border-t border-brand-teal/10" data-id="element-153">
            <div className="flex items-center gap-3" data-id="element-154">
              <div className="w-10 h-10 rounded-full bg-white shadow-sm flex items-center justify-center text-brand-teal flex-shrink-0" data-id="element-155">
                <Calendar size={20} data-id="element-156" />
              </div>
              <span className="text-sm font-medium text-brand-text" data-id="element-157">
                Weekly Service
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-158">
              <div className="w-10 h-10 rounded-full bg-white shadow-sm flex items-center justify-center text-brand-teal flex-shrink-0" data-id="element-159">
                <Droplet size={20} data-id="element-160" />
              </div>
              <span className="text-sm font-medium text-brand-text" data-id="element-161">
                Repairs
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-162">
              <div className="w-10 h-10 rounded-full bg-white shadow-sm flex items-center justify-center text-brand-teal flex-shrink-0" data-id="element-163">
                <MapPin size={20} data-id="element-164" />
              </div>
              <span className="text-sm font-medium text-brand-text leading-tight" data-id="element-165">
                Madison &<br data-id="element-166" />
                Surrounding Areas
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Image — below text on mobile, right side on desktop */}
      <div className="w-full h-[45vh] md:h-auto md:w-1/2 relative" data-id="element-167">
        <div className="absolute inset-0 bg-brand-teal/5 z-10" data-id="element-168"></div>
        <img src="https://cdn.magicpatterns.com/uploads/aMd1cGLmNCpT7Xc57WSsjP/pool-care-2.png" alt="Luxury pool in Madison, MS" className="w-full h-full object-cover" data-id="element-169" />
      </div>
    </section>;
}